import api from "./api";

async function uploadImage(
  id_professional: string,
  base64: string,
  fileName: string
) {
  try {
    const body = {
      base64,
      file_name: fileName,
    };
    const { data } = await api.post(`/images/upload/${id_professional}/`, body);
    return {
      file_name: data.file_name,
      url: data.url,
      path: data.path,
    };
  } catch (e) {
    console.log(e);
    return false;
  }
}

async function uploadImageWithUrl(
  id_professional: string,
  base64: string,
  fileName: string
) {
  try {
    const body = {
      base64,
      file_name: fileName,
    };
    const { data } = await api.post(
      `/images/upload-with-url/${id_professional}/`,
      body
    );
    return {
      file_name: data.file_name,
      url: data.url,
      path: data.path,
    };
  } catch (e) {
    console.error("Erro ao fazer upload:", e);
    return null;
  }
}

async function uploadFileWithUrl(
  id_professional: string,
  file: File
) {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const { data } = await api.post(
      `/images/upload-with-url/${id_professional}/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return {
      file_name: data.file_name,
      url: data.url,
      path: data.path,
    };
  } catch (e) {
    console.error("Erro ao fazer upload:", e);
    return null;
  }
}

const blob = {
  uploadImage,
  uploadImageWithUrl,
  uploadFileWithUrl,
};

export default blob;
